export const achievementData = {
    bio: "Certifications and Accolades",
    achievements: [
    {
      id: 1,
      title: 'ISC2 Certified in CyberSecurity',
      details: 'ISC2s certification to validate your entry-level cyber knowledge on concepts and scenarios.',
      date: 'September 1, 2023',
      field: 'CyberSecurity',
      image: require('../assets/png/CCCert.png').default,
      pdf: require('../assets/pdf/CCCert.pdf').default,
      isIframe: false
    },
    {
      id: 5,
      title: 'CompTIA Security+',
      details: 'CompTIA Security+ is the premier global certification that establishes the essential skills required for core security functions and a career in IT security. It showcases professionals capabilities in securing networks, applications, and devices, ensuring data integrity, confidentiality, and availability.',
      date: 'August 13, 2025',
      field: 'CyberSecurity',
      image: require('../assets/png/SecPlusCert.png').default,
      pdf: require('../assets/pdf/SecPlusCert.pdf').default,
      isIframe: false
    },
    {
      id: 2,
      title: 'NCAE 2025 Regional Champion',
      details: 'First place in the Northeast 2 Division with a final score of 5176',
      date: 'March 15, 2025',
      field: 'Cybersecurity/Defense',
      image: '', // No image path, will use iframe instead
      iframeSrc: 'https://api.badgr.io/public/assertions/_DipmsdJRsOgFCFkdD9AnA?embedVersion=1&embedWidth=330&embedHeight=191',
      pdf: '',
      isIframe: true
    },
    {
      id: 3,
      title: 'NCAE 2025 Invitational Winner',
      details: 'Third place nationally, First place in the Northeast. Achieved a record breaking 9007 points',
      date: 'April 12, 2025',
      field: 'Cybersecurity/Defense',
      image: '', // No image path, will use iframe instead
      iframeSrc: 'https://api.badgr.io/public/assertions/bA8l2S7sQwm_RQp_vVA01A?embedVersion=1&embedWidth=330&embedHeight=191',
      pdf: '',
      isIframe: true
    },
  ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/